import GroupedChart, { type GroupedChartProps } from './GroupedChart';

export type GroupedColumnChartProps = Omit<GroupedChartProps, 'mode'>;

const GroupedColumnChart = (props: GroupedColumnChartProps) => <GroupedChart {...props} mode="column" />;

export default GroupedColumnChart;
